module.exports = __webpack_public_path__ + "static/demo01-ps-usxp-d2b7e9e8d1e8832b82a19e3c2b3fda38.mp4";